import React from 'react';

import AlertContext from 'components/AlertContext';

const useAlert = () => {
  return React.useContext(AlertContext);
};

export default useAlert;
